<div class="supplier-report-container">
  <mat-card class="supplier-report-card">
    <mat-card-header class="supplier-report-header">
      <div>
        <mat-card-title>Reporte por Proveedor</mat-card-title>
        <mat-card-subtitle>Consulta las ventas y desempeño de tus proveedores</mat-card-subtitle>
      </div>
    </mat-card-header>

    <mat-card-content class="supplier-report-content">
      <div class="period-controls">
        <button mat-icon-button color="primary" (click)="changePeriod('prev')" [disabled]="!filterForm.get('startDate')?.value">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <div class="period-text">
          <h3>{{ periodTitle }}</h3>
          <p [class.clickable-date]="isDayView" (click)="openDayPicker()" *ngIf="isDayView; else normalSubtitle">
            {{ periodSubtitle }}
            <mat-icon class="date-picker-icon">calendar_today</mat-icon>
          </p>
          <ng-template #normalSubtitle>
            <p>{{ periodSubtitle }}</p>
          </ng-template>
        </div>
        <button mat-icon-button color="primary" (click)="changePeriod('next')" [disabled]="!filterForm.get('startDate')?.value">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <!-- Date picker oculto para selección de día -->
      <input matInput [matDatepicker]="dayPicker" style="display: none;" [value]="filterForm.get('startDate')?.value" (dateChange)="onDaySelected($event)">
      <mat-datepicker #dayPicker [startAt]="filterForm.get('startDate')?.value"></mat-datepicker>

      <form [formGroup]="filterForm" class="supplier-filter">
        <mat-form-field appearance="outline">
          <mat-label>Selecciona un proveedor</mat-label>
          <mat-select formControlName="proveedorId" [disabled]="loadingProviders">
            <mat-option value="">-- Selecciona --</mat-option>
            <mat-option *ngFor="let proveedor of providers" [value]="proveedor.id">
              {{ proveedor.nombre }}
            </mat-option>
          </mat-select>
          <mat-hint *ngIf="!loadingProviders">Total: {{ providers.length }}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Vista del reporte</mat-label>
          <mat-select formControlName="viewType">
            <mat-option value="today">Hoy</mat-option>
            <mat-option value="week">Semana actual</mat-option>
            <mat-option value="month">Mes actual</mat-option>
            <mat-option value="custom">Personalizado</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="filterForm.get('viewType')?.value === 'custom'">
          <mat-label>Fecha inicial</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="filterForm.get('viewType')?.value === 'custom'">
          <mat-label>Fecha final</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <button
          *ngIf="filterForm.get('viewType')?.value === 'custom' && filterForm.get('proveedorId')?.value"
          type="button"
          mat-flat-button
          color="primary"
          (click)="onFiltersChanged(true)"
          [disabled]="loadingReport || !filterForm.get('startDate')?.value || !filterForm.get('endDate')?.value">
          <mat-icon>refresh</mat-icon>
          Actualizar reporte
        </button>
      </form>

      <ng-container *ngIf="loadingReport">
        <div class="loading-state">
          <mat-spinner diameter="48"></mat-spinner>
          <p>Generando reporte...</p>
        </div>
      </ng-container>

      <ng-container *ngIf="!loadingReport && hasReport; else emptyTemplate">
        <div class="supplier-report-scroll">
          <section class="summary-grid" *ngIf="resumen">
            <mat-card class="summary-card">
              <mat-icon mat-card-avatar>paid</mat-icon>
              <div>
                <h4>Total ventas</h4>
                <span>{{ resumen?.totalVentas | currency }}</span>
              </div>
            </mat-card>

            <mat-card class="summary-card">
              <mat-icon mat-card-avatar>shopping_bag</mat-icon>
              <div>
                <h4>Productos vendidos</h4>
                <span>{{ resumen?.totalProductosVendidos }}</span>
              </div>
            </mat-card>

            <mat-card class="summary-card">
              <mat-icon mat-card-avatar>bar_chart</mat-icon>
              <div>
                <h4>Ganancias totales</h4>
                <span>{{ resumen?.gananciasTotales | currency }}</span>
              </div>
            </mat-card>

            <mat-card class="summary-card">
              <mat-icon mat-card-avatar>leaderboard</mat-icon>
              <div>
                <h4>Promedio por venta</h4>
                <span>{{ resumen?.promedioPorVenta | currency }}</span>
              </div>
            </mat-card>

            <mat-card class="summary-card">
              <mat-icon mat-card-avatar>receipt_long</mat-icon>
              <div>
                <h4>Cantidad de ventas</h4>
                <span>{{ resumen?.cantidadVentas }}</span>
              </div>
            </mat-card>
          </section>

          <section class="periodo-card" *ngIf="hasReport">
            <mat-icon>event</mat-icon>
            <div>
              <span>Periodo consultado</span>
              <strong>{{ periodSubtitle }}</strong>
            </div>
          </section>

          <section class="charts-grid" *ngIf="reportData?.ventasPorFecha?.length">
            <mat-card class="chart-card" *ngIf="reportData?.ventasPorFecha?.length">
              <div class="section-title">
                <h3>Ventas por fecha</h3>
              </div>
              <div class="chart-container">
                <canvas baseChart
                  [data]="barChartData"
                  [options]="barChartOptions"
                  [type]="barChartType">
                </canvas>
              </div>
            </mat-card>

            <mat-card class="chart-card" *ngIf="reportData?.ventasPorFecha?.length">
              <div class="section-title">
                <h3>Tendencia de ventas por fecha</h3>
              </div>
              <div class="chart-container">
                <canvas baseChart
                  [data]="lineChartData"
                  [options]="lineChartOptions"
                  [type]="lineChartType">
                </canvas>
              </div>
            </mat-card>
          </section>

          <section class="tables-grid">
            <mat-card class="table-card">
              <div class="section-title">
                <h3>Productos vendidos</h3>
              </div>

              <div class="table-scroll" *ngIf="productosOrdenados?.length; else emptyProducts">
                <table mat-table [dataSource]="productosOrdenados" class="mat-elevation-z8">
                  <ng-container matColumnDef="productoNombre">
                    <th mat-header-cell *matHeaderCellDef>Producto</th>
                    <td mat-cell *matCellDef="let item">
                      <strong>{{ item.productoNombre }}</strong>
                      <div class="muted">Código: {{ item.productoCodigo }}</div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="ultimaVenta">
                    <th mat-header-cell *matHeaderCellDef>Última venta</th>
                    <td mat-cell *matCellDef="let item">
                      {{ item.ultimaVenta ? (item.ultimaVenta | date:'dd/MM/yyyy HH:mm') : 'Sin registro' }}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="cantidadVendida">
                    <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                    <td mat-cell *matCellDef="let item">{{ item.cantidadVendida }}</td>
                  </ng-container>

                  <ng-container matColumnDef="totalVendido">
                    <th mat-header-cell *matHeaderCellDef>Total vendido</th>
                    <td mat-cell *matCellDef="let item">{{ item.totalVendido | currency }}</td>
                  </ng-container>

                  <ng-container matColumnDef="precioPromedio">
                    <th mat-header-cell *matHeaderCellDef>Precio promedio</th>
                    <td mat-cell *matCellDef="let item">{{ item.precioPromedio | currency }}</td>
                  </ng-container>

                  <ng-container matColumnDef="porcentajeDelTotal">
                    <th mat-header-cell *matHeaderCellDef>Participación</th>
                    <td mat-cell *matCellDef="let item">{{ item.porcentajeDelTotal | number:'1.0-2' }} %</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="['productoNombre','ultimaVenta','cantidadVendida','totalVendido','precioPromedio','porcentajeDelTotal']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['productoNombre','ultimaVenta','cantidadVendida','totalVendido','precioPromedio','porcentajeDelTotal'];"></tr>
                </table>
              </div>
              <ng-template #emptyProducts>
                <p class="empty-table">Este proveedor no registra ventas de productos en el periodo seleccionado.</p>
              </ng-template>
            </mat-card>

            <mat-card class="table-card">
              <div class="section-title">
                <h3>Ventas por fecha</h3>
              </div>

              <div class="table-scroll" *ngIf="reportData?.ventasPorFecha?.length; else emptySales">
                <table mat-table [dataSource]="reportData?.ventasPorFecha" class="mat-elevation-z8">
                  <ng-container matColumnDef="fecha">
                    <th mat-header-cell *matHeaderCellDef>Fecha</th>
                    <td mat-cell *matCellDef="let item">{{ item.fecha | date:'dd/MM/yyyy' }}</td>
                  </ng-container>

                  <ng-container matColumnDef="cantidadVentas">
                    <th mat-header-cell *matHeaderCellDef>Ventas</th>
                    <td mat-cell *matCellDef="let item">{{ item.cantidadVentas }}</td>
                  </ng-container>

                  <ng-container matColumnDef="totalVendido">
                    <th mat-header-cell *matHeaderCellDef>Total vendido</th>
                    <td mat-cell *matCellDef="let item">{{ item.totalVendido | currency }}</td>
                  </ng-container>

                  <ng-container matColumnDef="productosVendidos">
                    <th mat-header-cell *matHeaderCellDef>Productos</th>
                    <td mat-cell *matCellDef="let item">{{ item.productosVendidos }}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="['fecha','cantidadVentas','totalVendido','productosVendidos']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['fecha','cantidadVentas','totalVendido','productosVendidos'];"></tr>
                </table>
              </div>
              <ng-template #emptySales>
                <p class="empty-table">No se registraron ventas en el periodo seleccionado.</p>
              </ng-template>
            </mat-card>
          </section>

          <section class="top-products-section" *ngIf="top5Productos?.length">
            <mat-card class="table-card">
              <div class="section-title">
                <h3>Top 5 Productos Más Vendidos</h3>
              </div>
              <div class="table-scroll">
                <table mat-table [dataSource]="top5Productos" class="mat-elevation-z8">
                  <ng-container matColumnDef="posicion">
                    <th mat-header-cell *matHeaderCellDef>#</th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      <span class="position-badge">{{ i + 1 }}</span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="productoNombre">
                    <th mat-header-cell *matHeaderCellDef>Producto</th>
                    <td mat-cell *matCellDef="let item">
                      <strong>{{ item.productoNombre }}</strong>
                      <div class="muted">Código: {{ item.productoCodigo }}</div>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="cantidadVendida">
                    <th mat-header-cell *matHeaderCellDef>Cantidad vendida</th>
                    <td mat-cell *matCellDef="let item">
                      <span class="quantity-badge">{{ item.cantidadVendida }}</span>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="totalVendido">
                    <th mat-header-cell *matHeaderCellDef>Total vendido</th>
                    <td mat-cell *matCellDef="let item">
                      <strong class="total-amount">{{ item.totalVendido | currency }}</strong>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="precioPromedio">
                    <th mat-header-cell *matHeaderCellDef>Precio promedio</th>
                    <td mat-cell *matCellDef="let item">{{ item.precioPromedio | currency }}</td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="['posicion','productoNombre','cantidadVendida','totalVendido','precioPromedio']"></tr>
                  <tr mat-row *matRowDef="let row; columns: ['posicion','productoNombre','cantidadVendida','totalVendido','precioPromedio'];"></tr>
                </table>
              </div>
            </mat-card>
          </section>
        </div>
      </ng-container>

      <ng-template #emptyTemplate>
        <div class="empty-state" *ngIf="!loadingReport && !hasReport">
          <mat-icon>insert_chart_outlined</mat-icon>
          <h3>Selecciona un proveedor para ver su desempeño</h3>
          <p>Aquí verás ventas, productos y tendencias del proveedor elegido.</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>

